// Shared DOM `id` values for form fields rendered in more than one place.
//
// The room create form (AddRoom.jsx, /spaces/new) and the room edit form
// (RoomEdit.jsx, /spaces/edit/:id) are separate components that render the
// same logical fields. Centralizing the ids here keeps the two in sync and
// keeps `htmlFor` ↔ `id` associations correct — a typo in either component
// would otherwise silently break the label association (and the E2E page
// objects in e2e/pages/rooms/, which select these fields by id).

export const ROOM_FIELD_IDS = Object.freeze({
  name: 'room-name',
  type: 'room-type',
  floorLevel: 'floor-level',
  house: 'room-house',
  notes: 'room-notes',
});
